import { render } from "./Holder2.vue?vue&type=template&id=381bdcf2&scoped=true"
import script from "./Holder2.vue?vue&type=script&lang=js"
export * from "./Holder2.vue?vue&type=script&lang=js"

import "./Holder2.vue?vue&type=style&index=0&id=381bdcf2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381bdcf2"]])

export default __exports__